export const generateRequestId = () =>
  Math.round(Math.random() * 9999999999999).toString(16);
